import { Box, Button, HStack, Text, VStack } from '@chakra-ui/react'
import { toast } from 'react-toastify'
import type { RallyDayPlan } from '../mock-data'

interface INextUpFeaturedProps {
  plan: RallyDayPlan
}

const CARD_GRADIENT = 'linear-gradient(155deg, #1E4480 0%, #0E1F3C 100%)'
const BUTTON_GRADIENT = 'linear-gradient(180deg, #2E8FCC 0%, #1F72A6 12.31%, #093E76 102.38%)'
const BUTTON_GRADIENT_HOVER = 'linear-gradient(180deg, #3FA0DD 0%, #2987BC 12.31%, #0E4685 102.38%)'

const Chip = ({ children }: { children: React.ReactNode }) => (
  <Box
    px="10px"
    h="26px"
    borderRadius="6px"
    border="1px solid rgba(255,255,255,0.20)"
    bg="#070C1666"
    display="inline-flex"
    alignItems="center"
    justifyContent="center"
  >
    <Text fontSize="10px" fontWeight={600} color="white" m={0} letterSpacing="0.06em">
      {children}
    </Text>
  </Box>
)

const NextUpFeatured = ({ plan }: INextUpFeaturedProps) => {
  return (
    <Box bg={CARD_GRADIENT} borderRadius="16px" p="16px">
      <VStack spacing="10px" align="stretch">
        <Box
          alignSelf="flex-start"
          px="10px"
          h="22px"
          borderRadius="6px"
          bg="rgba(77,179,255,0.15)"
          display="inline-flex"
          alignItems="center"
        >
          <Text color="#4DB3FF" fontSize="10px" fontWeight={700} m={0} letterSpacing="0.10em">
            UP NEXT
          </Text>
        </Box>

        <Text color="white" fontSize="22px" fontWeight={700} m={0} lineHeight="1.2">
          {plan.routineTitle}
        </Text>
        <Text color="rgba(255,255,255,0.65)" fontSize="13px" m={0}>
          {plan.routineSubtitle}
        </Text>

        <HStack spacing="8px" mt="4px">
          {plan.routineDurationMin > 0 && <Chip>{plan.routineDurationMin} MIN</Chip>}
          {plan.routineReps > 0 && <Chip>{plan.routineReps} REPS</Chip>}
          {plan.equipment && <Chip>{plan.equipment.toUpperCase()}</Chip>}
        </HStack>

        <Button
          mt="6px"
          h="44px"
          w="100%"
          borderRadius="999px"
          bg={BUTTON_GRADIENT}
          color="white"
          fontSize="14px"
          fontWeight={600}
          border="none"
          _hover={{ bg: BUTTON_GRADIENT_HOVER }}
          _active={{ opacity: 0.92 }}
          _focus={{ boxShadow: 'none' }}
          _focusVisible={{ boxShadow: 'none' }}
          onClick={() => toast.info('Workout starting...')}
        >
          Start workout
        </Button>
      </VStack>
    </Box>
  )
}

export default NextUpFeatured
